import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Persistent scroll positions keyed by pathname
const scrollPositions: Record<string, number> = {};

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  const prevPathname = useRef(pathname);

  // Continuously track scroll position for the current route
  useEffect(() => {
    const handleScroll = () => {
      scrollPositions[pathname] = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname]);

  useEffect(() => {
    if (navType === "POP") {
      // Restore saved position on back/forward navigation
      const saved = scrollPositions[pathname];
      if (saved !== undefined) {
        // Wait for DOM to render before restoring
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            window.scrollTo({ top: saved, left: 0, behavior: "instant" });
          });
        });
      }
    } else {
      // Scroll to top for forward navigations (PUSH/REPLACE)
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }

    prevPathname.current = pathname;
  }, [pathname, navType]);

  return null;
};
